/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difficulty_MediumInputs */

const bn_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাঝারি`)
};

const de_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const el_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μέσον`)
};

const en_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const es_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio`)
};

const fr_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyen`)
};

const hi_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मध्यम`)
};

const hu_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közepes`)
};

const id_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang`)
};

const it_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio`)
};

const ja_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中くらい`)
};

const ko_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중간`)
};

const nl_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const pl_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Średni`)
};

const pt_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médio`)
};

const ru_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Середина`)
};

const sv_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const tr_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orta`)
};

const uk_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Середній`)
};

const vi_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trung bình`)
};

const zh_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中等的`)
};

const zh_hant_difficulty_medium = /** @type {(inputs: Difficulty_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中等的`)
};

/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Difficulty_MediumInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const difficulty_medium = /** @type {((inputs?: Difficulty_MediumInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difficulty_MediumInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_difficulty_medium(inputs)
	if (locale === "de") return de_difficulty_medium(inputs)
	if (locale === "el") return el_difficulty_medium(inputs)
	if (locale === "en") return en_difficulty_medium(inputs)
	if (locale === "es") return es_difficulty_medium(inputs)
	if (locale === "fr") return fr_difficulty_medium(inputs)
	if (locale === "hi") return hi_difficulty_medium(inputs)
	if (locale === "hu") return hu_difficulty_medium(inputs)
	if (locale === "id") return id_difficulty_medium(inputs)
	if (locale === "it") return it_difficulty_medium(inputs)
	if (locale === "ja") return ja_difficulty_medium(inputs)
	if (locale === "ko") return ko_difficulty_medium(inputs)
	if (locale === "nl") return nl_difficulty_medium(inputs)
	if (locale === "pl") return pl_difficulty_medium(inputs)
	if (locale === "pt") return pt_difficulty_medium(inputs)
	if (locale === "ru") return ru_difficulty_medium(inputs)
	if (locale === "sv") return sv_difficulty_medium(inputs)
	if (locale === "tr") return tr_difficulty_medium(inputs)
	if (locale === "uk") return uk_difficulty_medium(inputs)
	if (locale === "vi") return vi_difficulty_medium(inputs)
	if (locale === "zh") return zh_difficulty_medium(inputs)
	return zh_hant_difficulty_medium(inputs)
});